module.exports = __webpack_public_path__ + "img/Jump Casting131.c1651b78.jpg";